<template lang="html">
  <div class="">
    <v-tabs-items
      :value="$route.path"
      class="transparent"
    >
      <v-tab-item
        :id="tabs[0].to"
        class="fill-height"
        eager
      >
        <CalculatorsSetup
          :fields="fields"
          :calculator-id="calculatorId"
        />
      </v-tab-item>
      <v-tab-item
        :id="tabs[1].to"
        class="fill-height"
      >
        <CalculatorsFields
          :fields="fields"
          :calculator-id="calculatorId"
          :mapping="mapping"
        />
      </v-tab-item>
      <v-tab-item
        :id="tabs[2].to"
        class="fill-height"
      >
        <CalculatorsForms
          :fields="fields"
          :calculator-id="calculatorId"
          :mapping="mapping"
        />
      </v-tab-item>
      <v-tab-item
        :id="tabs[3].to"
        class="fill-height"
      >
        <CalculatorsReport
          :fields="fields"
          :calculator-id="calculatorId"
        />
      </v-tab-item>
      <v-tab-item
        :id="tabs[4].to"
        class="fill-height"
      >
        <CalculatorsTest
          :fields="fields"
          :calculator-id="calculatorId"
        />
      </v-tab-item>
      <v-tab-item
        :id="tabs[5].to"
        class="fill-height"
      >
        <CalculatorsWiki :calculator-id="calculatorId" />
      </v-tab-item>
      <v-tab-item
        :id="tabs[6].to"
        class="fill-height"
      >
        <CalculatorsNotes :calculator-id="calculatorId" />
      </v-tab-item>
    </v-tabs-items>
    <!-- <router-view :fields="fields" :calculator-id="calculatorId" :mapping="mapping"></router-view> -->
    <SiLoaderPopup
      :value="exporting"
      color="info"
      :label="`Exporting calculator`"
    />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import binder from '@/mixins/binder'
import helpers from '@/mixins/helpers'
import CalculatorsSetup from './CalculatorsSetup.vue'
import CalculatorsFields from './CalculatorsFields.vue'
import CalculatorsForms from './CalculatorsForms.vue'
import CalculatorsReport from './CalculatorsReport.vue'
import CalculatorsTest from './CalculatorsTest.vue'
import CalculatorsWiki from './CalculatorsWiki.vue'
import CalculatorsNotes from './CalculatorsNotes.vue'
export default {
  components: {
    CalculatorsSetup,
    CalculatorsFields,
    CalculatorsForms,
    CalculatorsReport,
    CalculatorsTest,
    CalculatorsWiki,
    CalculatorsNotes,
  },
  mixins: [ helpers, binder ],
  props: {

  },
  data () {
    return {
      panel: null,
      exporting: false,
      tab: 0,
      calculator: '',
      fields: {},
      mapping: {}
    }
  },
  computed: {
    ...mapGetters(['_calculators']),
    calculatorId () {
      return this.$route.params.sub
    },
    calculatorRoute () {
      return `/admin/calculators/${this.calculatorId}`
    },
    tabs () {
      return [
        { text: 'Overview', to: `${this.calculatorRoute}/setup` },
        { text: 'Fields', to: `${this.calculatorRoute}/fields` },
        { text: 'Forms', to: `${this.calculatorRoute}/forms` },
        { text: 'Report', to: `${this.calculatorRoute}/report` },
        { text: 'Test', to: `${this.calculatorRoute}/test` },
        { text: 'Wiki', to: `${this.calculatorRoute}/wiki` },
        { text: 'Notes', to: `${this.calculatorRoute}/notes` }
      ]
    }
  },
  watch: {
    '$route.params.sub' () {
      this.fields = {}
      this.mapping = {}
      this.$vuetify.goTo(0, { duration: 0 })
      this.$nextTick(() => {
        this.bindCalculator()
        this.initPage()
      })
    },
    _calculators () {
      this.initPage()
      // this.$router.replace({ path: this.$route.path, query: {} })
    }
  },
  beforeMount () {
    this.bindCalculator()
    this.$bindRtdbStore('set_assistanceTypes', `assistance/_types`)
    // this.$bindStorexxx(rtdb.ref('assistance/_types'),'set_assistanceTypes')
    this.initPage()
  },
  beforeDestroy () {
    this.$store.commit('set_appBarTabs', [])
  },
  methods: {
    initPage () {
      this.$store.commit('set_appBarTitle', { title: `${(this._calculators[this.calculatorId] || {}).name} - ${this.calculatorId}`, icon: 'settings' })
      this.$store.commit('set_appBarTabs', this.tabs)
      if (!this.$route.params.id) this.$router.replace(`${this.tabs[0].to}`)
    },
    bindCalculator () {
      this.$bindRtdb('fields', `calculators/${this.calculatorId}/structure/fields`, { loader: true })
      this.$bindRtdb('mapping', `calculators/${this.calculatorId}/structure/mapping`, { loader: true })
    
      // this.$unbindAll()
      // this.$bindxxx(rtdb.ref(`calculators/${this.calculatorId}/structure/fields`), 'fields', true)
      // this.$bindxxx(rtdb.ref(`calculators/${this.calculatorId}/structure/mapping`), 'mapping', true)
    }
  }
}
</script>

<style lang="css">

</style>
